import _objectSpread from "/builds/foxit/cloud/ac/phee_admin_console/frontend/manage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import platform from './node/index.js';
import * as utils from './common/utils.js';
export default _objectSpread({}, utils, platform);